import LoginForm from "../Components/LoginForm";

const LoginPage = () => {
  return (
    <div className="loginBox">
      <LoginForm />
    </div>
  );
};

export default LoginPage;
